import { Link } from "react-router-dom";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { cPath } from "../constants";
import useSEO from "../hooks/useSEO";

const Box = styled.div`
  text-align: center;
  padding: 5rem 1rem;
`;

const H1 = styled.h1`
  font-size: clamp(1.75rem, 1.2rem + 2vw, 2.75rem);
  font-weight: 800;
  margin: 0 0 0.5rem;
`;

const Lead = styled.p`
  margin: 0 0 1rem;
  font-size: clamp(0.9375rem, 0.88rem + 0.2vw, 1.0625rem);
  color: hsl(${({ theme }) => theme.colors.mutedForeground});
`;

export default function NotFoundPage() {
  const { t } = useTranslation();
  const seo = useSEO({
    title: "Page Not Found",
    description: "The page you are looking for does not exist.",
    noindex: true,
  });

  return (
    <>
      {seo}
      <Box>
      <H1>404</H1>
      <Lead>{t("common.pageNotExist")}</Lead>
      <Link to={cPath("")} style={{ color: "hsl(221 67% 44%)", fontWeight: 600 }}>
        {t("common.goHome")}
      </Link>
      </Box>
    </>
  );
}
